import { component } from 'picoapp';
import formatMoney from 'utils/format-money';

export default component(async (node) => {
  const formStrings = theme.strings.product.form;

  const initUpdate = () => {
    document.addEventListener('cart:updated', (event: CustomEvent) => {
      const { data } = event.detail;
      const freeShippingBalance = theme.config.shipping.freeShippingLimit - (data.final_price || 0);
      const hasFreeShipping = freeShippingBalance <= 0;

      let html: string;

      if (hasFreeShipping) {
        html = formStrings.freeShippingEarned;
      } else {
        html = formStrings.freeShippingConditioned;
        html = html.replace('%amount%', formatMoney(freeShippingBalance).toString());
      }

      node.innerHTML = html;
    });
  };

  const init = () => {
    initUpdate();
  };

  init();
});
